import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const CTAExpress = () => {
  const whatsappMessage =
    'Hola, me interesa la Propuesta Express Danimar x TNO Network ($99/mes, ecosistema completo TNO).';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
      >
        ¿Activamos la Propuesta Express?
      </Box>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        sx={{ mb: 3, maxWidth: 640, mx: 'auto' }}
      >
        12 spots diarios, 4 historias semanales en streaming, 4 reels al mes, 4 artículos TNO Digest y banners: todo el
        ecosistema TNO Network.
      </Typography>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="center"
        gap={2}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
            window.open(url, '_blank');
          }}
        >
          Contactar · Propuesta Express Danimar
        </Button>
        <Button
          href="https://www.tnonetwork.com"
          variant="outlined"
          color="primary"
          size="large"
          target="_blank"
          rel="noopener noreferrer"
        >
          Conocer TNO Network
        </Button>
      </Box>
    </Box>
  );
};

export default CTAExpress;
